export abstract class GraphService {
  private static endpoint = 'https://graph.microsoft.com/v1.0';

  protected static async get<T>(accessToken: string, action: string) {
    const options = GraphService.getOptions(accessToken, 'GET', null, null);
    const response: Response = await fetch(GraphService.endpoint + action, options);
    if (response.ok === false) {
      throw response;
    }
    return (await response.json()) as T;
  }

  protected static async post<T>(accessToken: string, action: string, model: any, headers?: Headers | null) {
    const options = GraphService.getOptions(accessToken, 'POST', model, headers);
    const response: Response = await fetch(GraphService.endpoint + action, options);
    if (response.ok === false) {
      throw response;
    }
    return (await response.json()) as T;
  }

  protected static async patch(accessToken: string, action: string, model: any, headers?: Headers | null) {
    const options = GraphService.getOptions(accessToken, 'PATCH', model, headers);
    const response: Response = await fetch(GraphService.endpoint + action, options);
    if (response.ok === false) {
      throw response;
    }
  }

  protected static async delete(accessToken: string, action: string, headers?: Headers | null) {
    const options = GraphService.getOptions(accessToken, 'DELETE', null, headers);
    const response: Response = await fetch(GraphService.endpoint + action, options);
    if (response.ok === false) {
      throw response;
    }
  }

  private static getOptions: (
    accessToken: string,
    method: string,
    model: any,
    headers?: Headers | null
  ) => RequestInit = (accessToken: string, method: string, model?: any, headers?: Headers | null) => {
    headers = headers || new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append('Authorization', bearer);
    headers.append('Content-Type', 'application/json');

    return {
      method: method,
      headers: headers,
      body: model ? JSON.stringify(model) : null
    };
  };
}
